import React from "react";

export default function Maintenance() {
  const style = {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "24px",
    textAlign: "center",
    fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, sans-serif",
    backgroundColor: "#f7f7f8",
    color: "#111827",
  };

  return (
    <main style={style}>
      <div>
        <h1>Site en maintenance</h1>
        <p>Nous revenons tres vite.</p>
      </div>
    </main>
  );
}
